<template>
  <gl-tree-view
    :entries="itemCategories"
    :selected="categories"
    v-on:update:selected="$emit('update:categories', $event)"
  />
</template>

<script>
import GlTreeView from '@/components/common/GlTreeView.vue'
import ErrorReport from '@/mixins/ErrorReport'

/**
 * 「商品モード - 分類選択時」コンポーネント
 *
 * 選択されている分類の一覧は、常に最下層のコード一覧を親コンポーネントと
 * 連動させます。
 */
export default {
  components: { GlTreeView },
  mixins: [ErrorReport],
  props: {
    /**
     * 分類をロードする対象の企業コード
     */
    company: {
      type: String,
    },
    // itemCategoryLevel: {
    //   type: Number,
    // },
    /**
     * 選択されているカテゴリ（最下層）
     */
    categories: {
      type: Array,
      default: () => [],
    },
    /**
     * 使用可能カテゴリ
     */
    availableItemCategory: {
      type: Object,
    },
  },
  watch: {
    company: {
      immediate: true,
      async handler(company) {
        if (company) {
          const categoriesTree = await this.$repositories
            .get('itemCategory')
            .get(company, {
              categoryLevel: this.availableItemCategory.categoryLevel,
              categories: this.availableItemCategory.categories,
            })
            .then(categories => [
              {
                code: undefined,
                name: '全分類',
                children: categories,
                open: true,
              },
            ])

          if (this.categories.length > 0) {
            const categoriesSet = new Set(this.categories)

            walk(categoriesTree[0], 0, entry => {
              if (entry.children) {
                return
              }
              entry.state = categoriesSet.has(entry.code) ? 'checked' : 'none'
            })
          }

          this.itemCategories = categoriesTree
        }
      },
    },
  },
  computed: {
    /**
     * 入力エラー
     */
    errors() {
      const errors = []

      if (!this.categories || this.categories.length === 0) {
        errors.push('分類を選択してください')
      }

      return errors
    },
  },
  data() {
    return {
      /**
       * 分類階層レベルマスタ
       */
      itemCategoryLevels: [],
      /**
       * ツリー用の分類の階層構造データ
       */
      itemCategories: [],
    }
  },
}

/**
 * ツリーノードの再帰処理
 */
function walk(entry, level, f) {
  if (entry.children) {
    for (const child of entry.children) {
      walk(child, level + 1, f)
    }
  }
  f(entry, level)
}
</script>

<style lang="scss" scoped>
.container {
  overflow: hidden;
}

.line {
  margin-top: 32px;
  &:first-child {
    margin-top: 0;
  }
}

.tree-view-container {
  height: 350px;
  overflow: auto;
  border: 1px solid var(--color-border);
  border-radius: 5px;
  padding: var(--spacing-medium);
}
</style>
